import PropTypes from 'prop-types';
import React from 'react';
import { Iterable } from 'immutable';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { StatusCell } from './CellFormatters.react';

const numRowsRenderer = ({ cellData }) => (
  cellData ?
  cellData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
  'n/a'
);

export default class SyncTable extends React.Component {
  constructor(props) {
    super(props);
    this.rowCount = this.rowCount.bind(this);
  }

  rowCount() {
    if (this.props.syncs) {
      return this.props.syncs.size;
    }
    return 0;
  }

  render() {
    return (<div className='tableContainer jobTable'>
      <AutoSizer>
        {({ height, width }) => (
          <Table
            height={height}
            width={width}
            rowGetter={({ index }) => this.props.syncs.get(index)}
            rowCount={this.rowCount()}
            rowHeight={50}
            headerHeight={50}
            className='mainTable'
          >
            <Column
              width={100}
              label='Status'
              dataKey='status'
              flexShrink={0}
              cellRenderer={StatusCell}
            />
            <Column
              width={200}
              flexGrow={1}
              label='Table'
              dataKey='tableName'
            />
            <Column
              width={150}
              flexShrink={1}
              label='Rows Updated'
              dataKey='numRowsUpdated'
              cellRenderer={numRowsRenderer}
            />
            <Column
              width={150}
              flexShrink={1}
              label='Last Loaded'
              dataKey='timestamp'
              cellRenderer={(({ cellData }) => cellData.fromNow())}
            />
          </Table>
        )}
      </AutoSizer>
    </div>);
  }
}

SyncTable.propTypes = {
  syncs: PropTypes.instanceOf(Iterable),
};
